import { Vue, Component, Prop } from "vue-property-decorator"
import { namespace, Mutation, Action, Getter } from "vuex-class"

const caseStore = namespace("cases")

@Component
export default class FileUpload extends Vue {
	@Prop({ type: Boolean, default: false })
	public creatingNewCase: boolean = false;

	@Prop({ type: String || null, default: null })
	public fieldId!: string | null;

	@Prop({ type: Boolean, default: false })
	public showUploadingFiles!: boolean;

	@caseStore.Getter("getPendingUploadFiles") public uploadingFiles!: any[];

	@caseStore.Action("uploadFiles") protected uploadFiles!: (uploadRequest: any) => void;

	@caseStore.Mutation("setFileNoLongerAwaitingUpload")
	protected fileNoLongerAwaitingUpload!: (filename: string) => void;

	protected uploadFieldName: any = "files";
	protected dragging: boolean = false;

	protected async onChange (event: any): Promise<void> {
		this.dragging = false

		let files = (event.target.files || event.dataTransfer.files) as any[]

		const uploadFiles: any[] = []
		files.forEach(file => {
			const newFile = {
				fieldId: this.fieldId,
				name: file.name,
				fileData: file,
				uploading: false,
				uploadPercentage: 0,
				failed: false,
				success: false,
				error: null,
				uploadRun: false
			}

			uploadFiles.push(newFile)
		})

		this.uploadFiles({ fieldId: this.fieldId, uploadFiles: uploadFiles })
	}
}
